export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-wide-line-abac305cc3bd142d4350d7456a88163c.svg";